import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function LightningFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.81606 2.69223C8.93717 2.42309 9.20487 2.25 9.5 2.25H18C18.2674 2.25 18.5145 2.39232 18.6487 2.62355C18.7829 2.85479 18.7838 3.13998 18.6512 3.3721L15.2924 9.25H19C19.3033 9.25 19.5768 9.43273 19.6929 9.71299C19.809 9.99324 19.7448 10.3158 19.5303 10.5303L8.53033 21.5303C8.29196 21.7687 7.92383 21.8187 7.63048 21.6527C7.33712 21.4866 7.19063 21.1451 7.2724 20.8181L9.03942 13.75H5C4.74551 13.75 4.50837 13.6209 4.37019 13.4072C4.232 13.1935 4.21162 12.9243 4.31606 12.6922L8.81606 2.69223Z"
				fill="currentColor"
			/>
		</svg>
	);
}

LightningFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default LightningFilledIcon;
